module.exports = __webpack_public_path__ + "media/images/icon-history-active-a71fa7fa14b3d2951219805e258f64e0.svg";